import { getAmplitudeInstance } from '../amplitudeHelpers';
import SearchTab from '../enums/SearchTab';
import SearchTabLocation from '../enums/SearchTabLocation';

type logSearchTabSwitchedParams = {
  search_tab_location?: SearchTabLocation;
  to_tab?: SearchTab;
};

/**
 * User switches between the 'location' and 'street address' tabs in the explore search on web. User can switch to street address by clicking tab or 'search by address' prompt.
 * @param params - Attributes to log with the amplitude event
 * @param params.search_tab_location - The map the user was on when the search tab was switched
 * @param params.to_tab - The tab that the user switched to
 */
const logSearchTabSwitched = ({ search_tab_location, to_tab }: logSearchTabSwitchedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('search tab switched', { 'search tab location': search_tab_location, 'to tab': to_tab }, callback);
};

export default logSearchTabSwitched;
